// CustomAlert.js
import React, { useEffect } from "react";
import Icon from "./ui/Icon";
import "../styles/CustomAlert.css";

export default function CustomAlert({ show, message, type = "success", onClose }) {
    // Esc closes the dialog
    useEffect(() => {
        if (!show) return undefined;
        const onKey = e => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [show, onClose]);

    if (!show) return null;

    return (
        <>
            {/* Full-screen overlay to block background clicks */}
            <div className="overlay" onClick={onClose}></div>

            <div
                className="custom-alert"
                role="alertdialog"
                aria-modal="true"
                aria-live="assertive"
            >
                <div className={`alert-icon ${type}`}>
                    <Icon name={type === "error" ? "alertCircle" : "check"} size={26} />
                </div>

                <div className="message">{message}</div>

                <button className="ok-btn btn btn-primary-mt" onClick={onClose} autoFocus>
                    OK
                </button>
            </div>
        </>
    );
}
